// Web adapter for the app's apply / withdraw hook (components/home/useClubApply.js):
// same logic and service calls; its alerts and toast state become web toasts.
import { useEffect } from "react";
import useClubApplyShared from "../../../components/home/useClubApply";
import { useToast } from "../components/Toast";

const ALERT_ICON = { error: "alert", warning: "alert", info: "info" };

export default function useClubApply({ user, refresh }) {
  const toast = useToast();
  const showAlert = (title, message, opts = {}) => toast(message || title, ALERT_ICON[opts.type] || "info");
  const { applyingClubId, applyBursts, onJoinPress, toast: state, hideToast } = useClubApplyShared({ user, showAlert, refresh });

  useEffect(() => {
    if (!state.visible) return;
    toast(state.message);
    hideToast();
  }, [state.visible, state.message, toast, hideToast]);

  return { applyingClubId, applyBursts, onJoinPress };
}
